"use strict";

exports.__esModule = true;
exports.default = regexValidation;

function regexValidation(customRegex) {
  var regex = new RegExp(customRegex);
  return function (value) {
    return regex.test(value);
  };
}

var regexEmail = exports.regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;